import { useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStore } from '@/stores';
import Header from '../Header';
import Sidebar from '../Sidebar';
import styles from './base.module.css';

const BaseLayout = observer(() => {
  const { tenants } = useStore();
  const { tenantId } = useParams();

  useEffect(() => {
    tenants.getTenants();
  }, [tenants]);

  useEffect(() => {
    if (tenants.tenantGroups.length > 0) {
      const selectedTenantId = tenants.tenantId || tenants.tenantGroups[0].id;
      const selectedTenant =
        tenants.tenantGroups.find(tenant => tenant.id === selectedTenantId) ||
        tenants.tenantGroups[0];
      tenants.setTenant(selectedTenant);
    }
  }, [tenantId, tenants, tenants.tenantGroups, tenants.tenantId]);

  return (
    <div className={styles.base}>
      <Header />
      <div className={styles.container}>
        <Sidebar />
        <main className={styles.main}>
          <div className={styles.inner}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
});

export default BaseLayout;
